import { Ics2ErrorLocation } from './types';

/** Worded to match the breadcrumb in `ProductsNavigation`, so the drawer and the form agree. */
export const formatIcs2ErrorLocation = (location?: Ics2ErrorLocation): string | undefined => {
    if (!location) return undefined;

    switch (location.level) {
        case 'master':
            return 'Master Information';
        case 'masterItem':
            return `Master Item ${location.itemIndex}`;
        case 'houseConsignment':
            return `House Consignment ${location.houseConsignmentIndex}`;
        case 'houseItem':
            return `House Consignment ${location.houseConsignmentIndex} | Item ${location.itemIndex}`;
    }
};
